import React, { InputHTMLAttributes } from 'react'
import { DolaThemes } from '../../styles/types'
import { StyledSliderCheckbox } from './styles'

interface SliderCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  theme?: DolaThemes
}

const SliderCheckbox: React.FC<SliderCheckboxProps> = ({
  theme = 'light',
  ...props
}) => {
  return (
    <StyledSliderCheckbox dolaTheme={theme}>
      <input type="checkbox" {...props} />
      <div className="slider"></div>
    </StyledSliderCheckbox>
  )
}

export default SliderCheckbox
